import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import cartReducer from './cartSlice';
import wishlistReducer from './wishlistSlice';
import productReducer from '../../modules/products/redux/product.reducers';
import categoryReducer from '../../modules/seller/redux/categorySlice';
import unitReducer from '../../modules/seller/redux/unitSlice';
import hsnCodeReducer from '../../modules/seller/redux/hsnCodeSlice';
import attributeReducer from '../../modules/seller/redux/attributeSlice';
import orderReducer from '../../modules/seller/redux/orderSlice';
import securityLogsReducer from '../../modules/supperadmin/redux/securityLogsSlice';
import sessionLogsReducer from '../../modules/supperadmin/redux/sessionLogsSlice';


export const store = configureStore({
    reducer: {
        auth          : authReducer,
        cart          : cartReducer,
        wishlist      : wishlistReducer,
        products      : productReducer,
        sellerCategory: categoryReducer,
        sellerUnit    : unitReducer,
        sellerHsn     : hsnCodeReducer,
        sellerAttr    : attributeReducer,
        sellerOrder   : orderReducer,
        securityLogs  : securityLogsReducer,
        sessionLogs   : sessionLogsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
